import MenuButton from '../MenuButton.jsx'
import useMenuItemImportSnapshot from './useMenuItemImportSnapshot.jsx'
import useMenuItemRefreshProduct from './useMenuItemRefreshProduct.jsx'
import useMenuItemUndoReviseProduct from './useMenuItemUndoReviseProduct.jsx'

export default function MenuButtonMore(props) {
    const items = [
        useMenuItemRefreshProduct(),
        useMenuItemUndoReviseProduct(),
        useMenuItemImportSnapshot(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            更多
        </MenuButton>
    )
}
